import { axiosInstance as axios } from 'hb-react/shared/utils/axios';

const mentionsOptions = {
  chars: ['@'],
  getOptionHtmlId: (index) => `mention-option-${index}`,
  linkRenderer: (mention, char) => ({
    link: Routes.user_path(mention.id),
    display: `${char}${mention.name}`,
    id: mention.id,
  }),
  fetchItems: (search) =>
    axios
      .get(
        Routes.quick_search_users_path({
          format: 'js',
          sort_by: 'lastname',
          term: search,
        }),
      )
      .then(({ data }) => data),
};

export default mentionsOptions;
